<template>
  <v-card
    :loading="loading"
    :style="`background: ${$vuetify.theme.dark ? '' : '#e4e4e4'};`"
  >
    <v-container>
      <v-row>
        <!-- ESTADO CONTRATO -->
        <v-col cols="12" sm="4">
          <v-card outlined class="mb-3">
            <v-card-title class="primary--text">{{
              $t("contratos.estado")
            }}</v-card-title>
            <v-divider></v-divider>
            <div class="pa-3">
              <div class="d-flex">
                <EstadoContrato
                  x-large
                  label
                  class="flex-grow-1 text-center mt-4"
                  :estado="contrato.estado"
                />
              </div>
              <h3 class="pl-2 mt-2">{{ contrato.explicacion_estado }}</h3>
              <template
                v-if="
                  contrato.estado == 'DEVOLVIENDO' ||
                  contrato.estado == 'DEVUELTO'
                "
              >
                <br />{{ $t("contratos.motivo_dev") }}:<br />
                <b>{{ contrato.motivodevolucion || contrato.comentario }}</b
                ><br />
              </template>
              <template v-if="contrato.estado == 'ANULADO'">
                <br />{{ $t("contratos.motivo_anu") }}:<br />
                <b>{{ contrato.motivoanulacion || contrato.comentario }}</b
                ><br />
              </template>
              <template v-if="contrato.estado == 'DETENIDO'">
                <br />{{ $t("contratos.motivo_det") }}:<br />
                <b>{{ contrato.motivodetencion || contrato.comentario }}</b
                ><br />
              </template>

              <template
                v-if="contrato.numerofactura && $root.acceso('FACTURAS')"
              >
                <strong>{{ $t("contratos.factura") }}:</strong>
                <v-divider class="mt-1 mb-2"></v-divider>
                <div class="d-flex" style="gap: 10px">
                  <span>Nº: </span>
                  <strong>{{ contrato.numerofactura }}</strong>
                </div>
                <div class="d-flex" style="gap: 10px">
                  <span>{{ $t("contratos.fecha") }}: </span>
                  <strong>{{ parseDate(contrato.fechafactura) }}</strong>
                </div>
                <div class="d-flex" style="gap: 10px">
                  <span>{{ $t("contratos.bimp") }}: </span>
                  <strong>{{ contrato.bifactura }}</strong>
                </div>
              </template>
              <!-- <v-btn class="mt-2" block v-if="$root.modules('TICKETING') && !contrato.refticket " color="primary"
                @click.stop="openTicket">
                <v-icon left>mdi-ticket</v-icon>
                Abrir consulta
              </v-btn>
              <v-btn v-else-if="$root.modules('TICKETING') && contrato.refticket" class="mt-2" block color="primary" :to="`/tickets/${ contrato.refticket }`" >
                <v-icon left>mdi-ticket</v-icon>
                Ver consulta
              </v-btn> -->
              <div class="mt-4">
                <v-btn
                  v-if="contrato.archivo"
                  block
                  @click.stop="verDocumento"
                  color="primary"
                >
                  <v-icon left>mdi-text-box</v-icon>
                  {{ $t("contratos.ver_doc") }}
                </v-btn>
                <v-btn
                  class="mt-2"
                  block
                  :to="`/facturas?_detailsId=${contrato.refpago}`"
                  v-if="
                    contrato.refpago &&
                    $root.modules('FACTURAS') &&
                    $root.acceso('FACTURAS')
                  "
                  color="primary"
                >
                  <v-icon left>mdi-text-box</v-icon>
                  {{ $t("contratos.ver_fac") }}
                </v-btn>
                <v-btn
                  class="mt-2"
                  block
                  :to="`/facturas?_detailsId=${contrato.refpago}`"
                  v-if="
                    contrato.refpago &&
                    $root.modules('FACTURAS') &&
                    $root.acceso('FACTURAS')
                  "
                  color="primary"
                >
                  <v-icon left>mdi-text-box</v-icon>
                  {{ $t("contratos.ver_fac") }}
                </v-btn>
                <!-- 
                <v-col cols="12" >
                  <v-btn class="mt-2" small color="primary" @click.stop="solicitarConsentimiento">Reenviar consentimiento</v-btn>
                </v-col> -->
              </div>

              <!-- BOTONES CONTRATACION AUTOMATICA -->
              <div
                class="mt-4"
                v-if="estados_anulables.includes(contrato.estado)"
              >
                <v-btn
                  v-if="
                    contrato.estado == 'PDT. VERIFICACION' &&
                    $root.acceso('FIRMAS')
                  "
                  color="primary"
                  class="mt-2"
                  block
                  @click.stop="solicitarConsentimiento"
                >
                  <v-icon left>mdi-mail</v-icon>
                  {{ $t("contratos.reenviar_consentimiento") }}
                </v-btn>
              </div>
              <div
                class="mt-4"
                v-if="estados_anulables.includes(contrato.estado)"
              >
                <v-btn
                  v-if="
                    contrato.estado == 'PDT. VERIFICACION' &&
                    $root.acceso('FIRMAS')
                  "
                  color="primary"
                  class="mt-2"
                  block
                  @click.stop="solicitarContrato"
                >
                  <v-icon left>mdi-mail</v-icon>
                  {{ $t("contratos.reenviar_contrato") }}
                </v-btn>
              </div>
              <!-- BOTONES CONTRATACION AUTOMATICA -->
              <!-- ANULAR -->
              <div
                class="mt-4"
                v-if="estados_anulables.includes(contrato.estado)"
              >
                <v-btn
                  class="mt-2"
                  block
                  @click.stop="addrefcomer"
                  color="primary"
                >
                  <v-icon left>mdi-pen</v-icon>
                  {{ $t("contratos.refcomer") }}
                </v-btn>
              </div>
              <!-- ANULAR -->
              <!-- AÑADIR REFS -->
              <div
                class="mt-4"
                v-if="estados_anulables.includes(contrato.estado)"
              >
                <v-btn
                  class="mt-2"
                  block
                  @click.stop="anularContrato"
                  color="primary"
                >
                  <v-icon left>mdi-close-octagon</v-icon>
                  {{ $t("contratos.anular") }}
                </v-btn>
              </div>
              <!-- AÑADIR REFS -->
            </div>
          </v-card>
        </v-col>
        <!-- ESTADO CONTRATO -->

        <!-- DATOS CONTRATO -->
        <v-col cols="12" sm="8">
          <v-card outlined class="mb-3">
            <v-card-title class="primary--text">{{
              $t("contratos.datos")
            }}</v-card-title>
            <v-divider></v-divider>
            <div class="pa-3">
              <InfoInput
                :title="$t('borradores.comer')"
                v-if="contrato.comercializadora"
                :value="contrato.comercializadora"
              >
              </InfoInput>
              <InfoInput
                :title="$t('borradores.tarifa')"
                :value="contrato.descTarifa"
              ></InfoInput>
              <InfoInput
                :title="$t('borradores.cups')"
                :value="contrato.cups"
              ></InfoInput>
              <div v-if="contrato.cups2">
                <InfoInput
                  :title="$t('borradores.tarifa2')"
                  :value="contrato.TARIFATARIFA2"
                ></InfoInput>
                <InfoInput
                  :title="$t('borradores.cups2')"
                  :value="contrato.cups2"
                ></InfoInput>
              </div>
              <InfoInput
                :title="$t('borradores.nombre_titular')"
                :value="contrato.cliente"
              ></InfoInput>
              <InfoInput
                :title="$t('borradores.dni_titular')"
                :value="contrato.nif_cif_titular"
              ></InfoInput>
              <InfoInput
                :title="$t('borradores.telefono')"
                :value="contrato.telefono1"
              ></InfoInput>
              <InfoInput
                :title="$t('borradores.telefono2')"
                v-if="contrato.telefono2"
                :value="contrato.telefono2"
              >
              </InfoInput>
              <InfoInput
                :title="$t('borradores.email')"
                v-if="contrato.email"
                :value="contrato.email"
              ></InfoInput>
              <InfoInput
                :title="$t('borradores.iban')"
                v-if="contrato.iban"
                :value="contrato.iban"
              ></InfoInput>
              <InfoInput
                :title="$t('borradores.dir_cups')"
                :value="contrato.direccion_punto_suministro"
              ></InfoInput>
              <InfoInput
                :title="$t('borradores.cp_cups')"
                :value="contrato.cp_cups"
              ></InfoInput>
              <InfoInput
                :title="$t('borradores.email')"
                :value="contrato.email"
              ></InfoInput>
              <InfoInput
                :title="$t('borradores.telf')"
                :value="
                  [contrato.telefono1, contrato.telefono2]
                    .filter((x) => !!x)
                    .join(' // ')
                "
              ></InfoInput>
              <!-- REFCOMER -->
              <InfoInput
                :title="$t('borradores.io')"
                v-if="contrato.REFCOMER"
                :value="contrato.REFCOMER"
              >
              </InfoInput>
              <InfoInput
                :title="$t('borradores.necesidad')"
                v-if="contrato.REFCOMER2"
                :value="contrato.REFCOMER2"
              >
              </InfoInput>
              <InfoInput
                :title="$t('contratos.comentario')"
                v-if="contrato.comentario"
                :value="contrato.comentario"
              >
              </InfoInput>
              <InfoInput
                :title="$t('borradores.otros')"
                v-if="contrato.otrosdatos"
                :value="contrato.otrosdatos"
              >
              </InfoInput>

              <InfoInput
                :title="$t('contratos.agente')"
                v-if="contrato.refagente"
                :value="contrato.nombreagente"
              >
              </InfoInput>
            </div>
          </v-card>
        </v-col>
        <!-- DATOS CONTRATO -->

        <!-- <v-col cols="12" sm="4" v-if="$root.modules('VERIFICACIONES')">
          <SubidaVerificacion @reload="getContrato" :contrato="contrato" />
        </v-col> -->

        <v-col cols="12" md="8" v-if="contrato.documentos">
          <DocumentosContrato
            @uploaded="getContrato"
            :refcontrato="contrato.ref"
            :docs="contrato.documentos"
            :estado="contrato.estado"
          />
          <!-- campo para añadir notas en historico -->
          <div class="mt-4">
            <v-card class="pa-3" outlined>
              <v-textarea
                v-model="nuevaNota"
                label="Añadir nota al histórico"
                outlined
                dense
                rows="2"
                class="mt-2"
              />
              <v-btn @click="addHistoricoNote" color="primary" class="mt-2">
                {{ $t("contratos.anadir_nota") }}
              </v-btn>
            </v-card>
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <v-card outlined class="mb-3">
            <v-card-title class="primary--text">{{
              $t("contratos.historico")
            }}</v-card-title>
            <v-divider class="mb-4"></v-divider>

            <v-timeline dense v-if="Array.isArray(contrato.historico)">
              <v-timeline-item v-for="hist in filteredHistorico" :key="hist.Id">
                <v-card class="pa-2">
                  <v-card-subtitle class="pa-0"
                    >{{ parseDate(hist.fecha, false, true, true) }}
                    <!-- - {{ hist.nombreadministrador }} -->
                  </v-card-subtitle>
                  <v-card-title class="pa-0">{{ hist.asunto }}</v-card-title>
                  <v-card-text class="pa-0" v-if="hist.comentario">{{
                    hist.comentario
                  }}</v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" md="6">
          <Chat :refcontrato="detailsId" />
        </v-col> -->
      </v-row>
    </v-container>
    <ConfirmDialog ref="confirm" />
    <!-- DIALOGO PARA AÑADIR REFCOMER -->
    <v-dialog v-model="dialogRefcomer" max-width="500px">
      <v-card>
        <v-card-title class="headline">Añadir referencias</v-card-title>
        <v-card-text>
          <v-text-field v-model="refcomer" label="IO" outlined dense />
          <v-text-field v-model="refcomer2" label="Necesidad" outlined dense />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogRefcomer = false">Cancelar</v-btn>
          <v-btn color="primary" @click="guardarRefcomer"> Guardar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { parseDate, downloadFile } from "@/utils/index.js";
import contratos from "..";
import ConfirmDelete from "@/components/ConfirmDelete.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { email } from "@/utils/validations";
export default {
  props: {
    detailsId: Number | String,
  },
  components: {
    ConfirmDialog: () => import("@/components/ConfirmDialog.vue"),
    ConfirmDelete: () => import("@/components/ConfirmDelete.vue"),
    Chat: () => import("../components/Chat/Chat.vue"),
    EstadoContrato: () => import("../components/EstadoContrato.vue"),
    InfoInput: () => import("../components/InfoInput.vue"),
    SubidaVerificacion: () => import("../components/SubidaVerificacion.vue"),
    DocumentosContrato: () => import("../components/DocumentosContrato.vue"),
  },
  data() {
    return {
      dialogRefcomer: false,
      refcomer: "",
      refcomer2: "",
      _contrato: {},
      documentoVerificacion: null,
      estados_anulables: [
        "PDT. VERIFICACION",
        "PENDIENTE",
        "TRAMITADO",
        "PDTE.FIRMA",
      ],
      loading: true,
    };
  },
  computed: {
    filteredHistorico() {
      if (!Array.isArray(this.contrato?.historico)) return [];

      return this.contrato.historico;
    },
    addrefcomer() {
      this.refcomer = this.contrato.REFCOMER || "";
      this.refcomer2 = this.contrato.REFCOMER2 || "";
      this.dialogRefcomer = true;
    },

    contrato() {
      return !this.loading
        ? new Proxy(this._contrato, {
            get: function (target, key) {
              if (typeof key == "string") {
                var uKey = key.toUpperCase();

                if (key != uKey && key in target) return target[key];
                return target[uKey];
              }
              return target[key];
            },
          })
        : {};
    },
  },
  methods: {
    parseDate,
    async getContrato() {
      if (!this.detailsId) return;
      this.loading = true;
      const { data } = await axios({
        method: "GET",
        url: `/contratos/${this.detailsId}`,
      });
      this._contrato = data;
      this.loading = false;
    },
    async solicitarConsentimiento() {
      if (
        !(await this.$refs.confirm.open(
          this.$t("confirm.enviar_consentimiento.title"),
          this.$t("confirm.enviar_consentimiento.text"),
          { color: "primary", confirmColor: "primary" }
        ))
      )
        return;

      this.loading = true;

      axios({
        method: "POST",
        url: `/consentimiento/reenviar_consentimiento/${this._contrato.ref}`,
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => {
          this.$root.$emit(
            "snack",
            this.$t("confirm.enviar_consentimiento.ok_result"),
            { color: "success" }
          );
        })
        .catch((err) => {
          let msg = err?.response?.data?.detail;
          this.$root.$emit(
            "snack",
            msg || this.$t("confirm.enviar_consentimiento.error_result"),
            { color: "error", type: "error" }
          );
        })
        .finally(() => (this.loading = false));
    },
    async solicitarContrato() {
      if (
        !(await this.$refs.confirm.open(
          this.$t("confirm.enviar_contrato.title"),
          this.$t("confirm.enviar_contrato.text"),
          { color: "primary", confirmColor: "primary", addExplanation: false }
        ))
      )
        return;

      this.loading = true;
      axios({
        method: "POST",
        url: `/contratos/reenviar_contrato/${this._contrato.ref}`,
      })
        .then((res) => {
          this.$root.$emit(
            "snack",
            this.$t("confirm.enviar_contrato.ok_result"),
            { color: "success" }
          );
        })
        .catch((err) => {
          let msg = err?.response?.data?.detail;
          this.$root.$emit(
            "snack",
            msg || this.$t("confirm.enviar_contrato.error_result"),
            { color: "error", type: "error" }
          );
        })
        .finally(() => (this.loading = false));
    },
    async verDocumento() {
      try {
        const { data } = await axios({
          method: "GET",
          url: `/contratos/documento/${this.contrato.archivo}`,
          responseType: "blob",
        });

        downloadFile(data, true);
      } catch {
        this.$root.$emit("snack", this.$t("documentacion.not_found"));
      }
    },
    async openTicket() {
      const { data } = await axios({
        method: "POST",
        url: `/tickets`,
        data: {
          refcontrato: this.contrato.ref,
          tipo: "ASISTENCIA SOBRE CONTRATO",
        },
      });

      this.$router.push(`/tickets/${data.idTicket}`);
    },
    async anularContrato() {
      const confirm = await this.$refs.confirm.open(
        this.$t("confirm.anular.title"),
        this.$t("confirm.anular.text"),
        false,
        {
          color: "error darken-2",
          confirmColor: "error darken-2",
          addExplanation: true,
        }
      );

      if (!confirm || typeof confirm !== "object") return;

      try {
        const { data } = await axios({
          method: "PUT",
          url: `/contratos/anular/${this._contrato.ref}`,
          data: {
            motivo: confirm.explanation,
          },
        });

        this.$root.$emit("snack", this.$t("confirm.anular.ok_result"));
        this.getContrato();
      } catch (error) {
        this.$root.$emit("snack", this.$t("confirm.anular.error_result"));
        console.error("Error al anular contrato:", error);
      }
    },
    async addHistoricoNote() {
      if (!this.nuevaNota || this.nuevaNota.trim() === "") {
        this.$root.$emit("snack", "La nota no puede estar vacía.", {
          color: "error",
        });
        return;
      }
      const comentario = this.nuevaNota.trim().replace(/'/g, "''");

      try {
        const ref = this._contrato.ref;
        const comentario = encodeURIComponent(this.nuevaNota.trim());

        await axios.post(
          `/contratos/addHistorico/${ref}?comentario=${comentario}`,
          {}
        );

        this.$root.$emit("snack", "Nota añadida correctamente.", {
          color: "success",
        });
        this.nuevaNota = "";
        this.getContrato();
      } catch (error) {
        this.$root.$emit("snack", "Error al añadir la nota.", {
          color: "error",
        });
        console.error("Error al añadir nota al histórico:", error);
      }
    },
    async guardarRefcomer() {
      try {
        const ref = this._contrato.ref;

        await axios.post(
          `/contratos/actualizar_refcomer/${ref}`,
          {},
          {
            params: {
              refcomer: this.refcomer || "",
              refcomer2: this.refcomer2 || "",
            },
          }
        );

        this.$root.$emit("snack", "Referencias actualizadas correctamente.", {
          color: "success",
        });

        this.dialogRefcomer = false;
        this.getContrato();
      } catch (error) {
        console.error(error);
        this.$root.$emit("snack", "Error al actualizar las referencias.", {
          color: "error",
        });
      }
    },
  },
  mounted() {
    this.getContrato();
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: var(--v-primary-base);
  font-size: 1.6rem !important;
}
</style>
